<template>
  <div>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.VoucherPin')">
            <Vouchers />
          </vs-tab>

          <vs-tab :label="$t('setup.label.VendorManagement')">
            <Vendor />
          </vs-tab>
          <vs-tab :label="$t('setup.label.IpManagement')">
            <Ip />
          </vs-tab>
          <vs-tab :label="$t('setup.label.SIMNumber')">
            <Sim />
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import VxCard from "@/components/vx-card/VxCard.vue";
import Vouchers from "./VoucherPins/vouchers.vue";
import Vendor from "./Vendor_Management/view_vendor_mgmt.vue";
import Ip from "./IpManagement/Index.vue";
import Sim from "./SimNumber/NumberList.vue";
export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  components: {
    VxCard,
    Vouchers,
    Vendor,
    Ip,
    Sim,
  },
};
</script>
